import requests from '@/utils/requests';

/**
 * 创建定时任务
 * @param {*} data
 */
export function schedulerCreate (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/scheduler/create',
    method: 'post',
    data
  });
}

/**
 * 定时任务列表
 * @param {*} data
 */
export function schedulerList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/scheduler/list',
    method: 'post',
    data
  });
}

/**
 * 已注册的任务列表
 * @param {*} data
 */
export function schedulerRegisteredList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/scheduler/registeredList',
    method: 'post',
    data
  });
}

/**
 * 修改定时任务
 * @param {*} data
 */
export function schedulerModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/scheduler/modify',
    method: 'post',
    data
  });
}

/**
 * 执行定时任务
 * @param {*} data
 */
export function schedulerRun (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/scheduler/run',
    method: 'post',
    data
  });
}

/**
 * 修改定时任务状态
 * @param {*} data
 */
export function schedulerModifyStatus (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/scheduler/modifyStatus',
    method: 'post',
    data
  });
}
